const BOUNDARY_SELECTOR = '[data-slot="download-manager-boundary"]';
const PANEL_SELECTOR = `${BOUNDARY_SELECTOR} [data-dock-corner]`;

/** Watches a sibling overlay that may mount after the voice call begins. */
export function observeDownloadManagerGeometry(update: () => void): () => void {
  let boundary: Element | null = null;
  let panel: Element | null = null;
  let frame: number | null = null;
  const schedule = () => {
    if (frame !== null) return;
    frame = window.requestAnimationFrame(() => {
      frame = null;
      update();
    });
  };
  const resize = new ResizeObserver(schedule);
  const geometry = new MutationObserver(schedule);
  const sync = () => {
    const nextBoundary = document.querySelector(BOUNDARY_SELECTOR);
    const nextPanel = document.querySelector(PANEL_SELECTOR);
    if (nextBoundary === boundary && nextPanel === panel) return;
    if (panel) resize.unobserve(panel);
    geometry.disconnect();
    boundary = nextBoundary;
    panel = nextPanel;
    if (panel) resize.observe(panel);
    if (boundary) {
      // Motion changes transforms while docking and morphing. Attribute changes
      // complement ResizeObserver, which cannot observe position alone.
      geometry.observe(boundary, {
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class', 'data-dock-corner'],
      });
    }
    schedule();
  };
  const mounts = new MutationObserver(sync);
  mounts.observe(document.body, { childList: true, subtree: true });
  sync();
  return () => {
    mounts.disconnect();
    geometry.disconnect();
    resize.disconnect();
    if (frame !== null) window.cancelAnimationFrame(frame);
  };
}
